import { render } from "./SideBarMenu.vue?vue&type=template&id=63eaac92&ts=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=ts"
export * from "./SideBarMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__